import type { Media } from '@funkey/api/src/features';

export function ImageApi_createURL(entity: Media.EntityFK) {
    return `/api/image/${entity.attachableType}/${entity.attachableId}` as const;
}
